import { Component, Input } from '@angular/core';
import { MarketDealResponse } from '../../models/response.module';
import { Router } from '@angular/router';
import { AuthService } from '../../../@core/services/auth.service';

@Component({
  selector: 'app-deal-card',
  standalone: false,
  templateUrl: './deal-card.html',
  styleUrl: './deal-card.css'
})
export class DealCard {
  @Input() deal: MarketDealResponse;
  @Input() showCompanyInfo: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  get isLoggedIn(): boolean {
    return this.authService.isLoggedIn();
  }

  get isCodeHidden(): boolean {
    return this.deal.discount_code_hidden === true || !this.isLoggedIn;
  }

  isDealActive(): boolean {
    const now = new Date();
    const startDate = new Date(this.deal.start_date);
    const endDate = new Date(this.deal.end_date);
    return this.deal.is_active && startDate <= now && endDate >= now;
  }

  goToStore() {
    if (this.deal.company_id) {
      this.router.navigate(['/stores-services', this.deal.company_id]);
    }
  }

  goToRegister() {
    this.router.navigate(['/auth/register-user']);
  }
}
